import script from "./TransferSelect.vue?vue&type=script&setup=true&lang=js"
export * from "./TransferSelect.vue?vue&type=script&setup=true&lang=js"

import "./TransferSelect.vue?vue&type=style&index=0&id=b0545650&scoped=true&lang=css"
import "./TransferSelect.vue?vue&type=style&index=1&id=b0545650&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b0545650"]])

export default __exports__